// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2CdHv","colBig":"styles_colBig__28tY9","colSmall":"styles_colSmall__2xb5V","shopifyNameWrapper":"styles_shopifyNameWrapper__LCRUw"};